/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsPresentationOptions, FxIdDomainSettingsPresentationOptionsFromJSONTyped, FxIdDomainSettingsPresentationOptionsToJSON, } from './FxIdDomainSettingsPresentationOptions';
export function FxIdWebFeaturesPlayGameResponsePresentationFromJSON(json) {
    return FxIdWebFeaturesPlayGameResponsePresentationFromJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameResponsePresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPresentationOptions(json)) {
        return FxIdDomainSettingsPresentationOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesPlayGameResponsePresentationToJSON(json) {
    return FxIdWebFeaturesPlayGameResponsePresentationToJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameResponsePresentationToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsPresentationOptions(value)) {
        return FxIdDomainSettingsPresentationOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesPlayGameResponsePresentation.js.map